import { AgGridModule } from '@ag-grid-community/angular';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import { HeaderRendererComponent } from '@frk/eds-components';
import { FundListingModule } from '@products/fund-listing/fund-listing.module';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { SharedModule } from '@shared/shared.module';
import { FundNameGroupHeaderComponent } from './fund-name-group-header/fund-name-group-header.component';
import { MorningstarTableComponent } from './morningstar-table.component';

@NgModule({
  declarations: [MorningstarTableComponent, FundNameGroupHeaderComponent],
  imports: [
    BrSdkModule,
    CommonModule,
    SharedModule,
    FundListingModule,
    AgGridModule.withComponents([
      HeaderRendererComponent,
      FundNameGroupHeaderComponent,
    ]),
  ],
})
export class MorningstarTableModule implements DynamicModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }
  getComponentMapping(): ComponentMapping {
    return {
      'Fund Morningstar': MorningstarTableComponent,
    };
  }
}
